import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TourPackageTable from "../../tourPackage/ui/TourPackageTable";
import { Box, Button, Stack, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";

const TourPackagePage = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("authUser"));
    if (storedUser) setUser(storedUser);
  }, []);

  if (!user) return null;

  return (
    <Box sx={{ minHeight: "100vh", p: { xs: 2, md: 4 }, bgcolor: "#F7F8FC" }}>
      {/* Page header */}
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={3}>
        <Box>
          <Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
            <ExploreOutlinedIcon sx={{ color: "primary.main", fontSize: 22 }} />
            <Typography variant="h5" fontWeight={700} color="text.primary">
              My Tour Packages
            </Typography>
          </Stack>
          <Typography variant="body2" color="text.secondary">
            Manage and publish your tour catalog for distributors.
          </Typography>
        </Box>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate("/create-package")}
        >
          New Package
        </Button>
      </Stack>

      <TourPackageTable />
    </Box>
  );
};

export default TourPackagePage;
